var toS = require('./toS')

/**
 * @desc Checks if `value` is classified as a `Map` object.
 * @param  {*} x value
 * @return {boolean} isMap
 *
 * @since 3.0.0
 * @memberOf is
 * @func isMap
 * @see https://github.com/jonschlinkert/kind-of
 *
 * @example
 *
 *  isMap(new Map())
 *  //=> true
 *  isMap(new Map.entries())
 *  //=> false
 *  isMap(new Set())
 *  //=> false
 *  isMap({})
 *  //=> false
 *  isMap('')
 *  //=> false
 *  isMap(1)
 *  //=> false
 *  isMap(new WeakMap)
 *  // => false
 *
 * @example
 *
 *  const e = {}
 *  eh[Symbol.toStringTag] = '[object Map]'
 *  isMap(eh)
 *
 * @example
 *
 *  class Eh extends Map()
 *  isMap(new Eh())
 *  //=> true
 *
 */
module.exports = function (x) { return x instanceof Map || toS(x) === '[object Map]'; }

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWFwLmpzIiwic291cmNlcyI6WyJtYXAuanMiXSwic291cmNlc0NvbnRlbnQiOlsiY29uc3QgdG9TID0gcmVxdWlyZSgnLi90b1MnKVxuXG4vKipcbiAqIEBkZXNjIENoZWNrcyBpZiBgdmFsdWVgIGlzIGNsYXNzaWZpZWQgYXMgYSBgTWFwYCBvYmplY3QuXG4gKiBAcGFyYW0gIHsqfSB4IHZhbHVlXG4gKiBAcmV0dXJuIHtib29sZWFufSBpc01hcFxuICpcbiAqIEBzaW5jZSAzLjAuMFxuICogQG1lbWJlck9mIGlzXG4gKiBAZnVuYyBpc01hcFxuICogQHNlZSBodHRwczovL2dpdGh1Yi5jb20vam9uc2NobGlua2VydC9raW5kLW9mXG4gKlxuICogQGV4YW1wbGVcbiAqXG4gKiAgaXNNYXAobmV3IE1hcCgpKVxuICogIC8vPT4gdHJ1ZVxuICogIGlzTWFwKG5ldyBNYXAuZW50cmllcygpKVxuICogIC8vPT4gZmFsc2VcbiAqICBpc01hcChuZXcgU2V0KCkpXG4gKiAgLy89PiBmYWxzZVxuICogIGlzTWFwKHt9KVxuICogIC8vPT4gZmFsc2VcbiAqICBpc01hcCgnJylcbiAqICAvLz0+IGZhbHNlXG4gKiAgaXNNYXAoMSlcbiAqICAvLz0+IGZhbHNlXG4gKiAgaXNNYXAobmV3IFdlYWtNYXApXG4gKiAgLy8gPT4gZmFsc2VcbiAqXG4gKiBAZXhhbXBsZVxuICpcbiAqICBjb25zdCBlID0ge31cbiAqICBlaFtTeW1ib2wudG9TdHJpbmdUYWddID0gJ1tvYmplY3QgTWFwXSdcbiAqICBpc01hcChlaClcbiAqXG4gKiBAZXhhbXBsZVxuICpcbiAqICBjbGFzcyBFaCBleHRlbmRzIE1hcCgpXG4gKiAgaXNNYXAobmV3IEVoKCkpXG4gKiAgLy89PiB0cnVlXG4gKlxuICovXG5tb2R1bGUuZXhwb3J0cyA9IHggPT4geCBpbnN0YW5jZW9mIE1hcCB8fCB0b1MoeCkgPT09ICdbb2JqZWN0IE1hcF0nXG4iXSwibmFtZXMiOlsiY29uc3QiXSwibWFwcGluZ3MiOiJBQUFBQSxHQUFLLENBQUMsR0FBRyxHQUFHLE9BQU8sQ0FBQyxPQUFPLENBQUM7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQTBDNUIsTUFBTSxDQUFDLE9BQU8sR0FBRyxVQUFBLENBQUMsQ0FBQSxDQUFDLEFBQUcsU0FBQSxDQUFDLFlBQVksR0FBRyxJQUFJLEdBQUcsQ0FBQyxDQUFDLENBQUMsS0FBSyxjQUFjLEdBQUE7In0=